import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import LemonIMUI from "../packages";

import { Popup, Field, CellGroup, Button, Toast, Dialog, ImagePreview } from 'vant';
import 'vant/lib/index.css';

Vue.use(Popup).use(CellGroup).use(Field).use(Button).use(Toast).use(Dialog).use(ImagePreview);

Vue.use(LemonIMUI);
Vue.prototype.$imagePreview = ImagePreview;
// Vue.use(Element);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
